import UIListener from '@/UIListener/UIListener';
import DetailViewContext from '@/ViewModels/Contexts/DetailViewContext';
import ComponentManager from '@/Management/ComponentManager';
import { ConditionalVisibilityUIListenerParams, ConditionalVisibilityUIListenerRule, PropertyClearUIListenerParams, PropertyClearUIListenerRule } from '#/DefaultViewExtensionInterfaces';
import ControlFactory from '@/Factories/ControlFactory';

export default class ConditionalVisibilityUIListener extends UIListener {

    private readonly rules: PropertyClearUIListenerRule[];
    private readonly myrules: ConditionalVisibilityUIListenerRule[];

    constructor(params: ConditionalVisibilityUIListenerParams) {
        super();

        this.myrules = this.paramOrDefault(params.rules, []);
    }

    /**
     * @override
     */
    public onPropertyValueUpdated(context: DetailViewContext, property: string) {
        this.checkRules(context, property);
    }

    /**
     * @override
     */
    public onDetailViewReady(context: DetailViewContext) {
        this.checkRules(context);
    }
    

    private checkRules(context: DetailViewContext, property?: string): void {
        for (const rule of this.myrules) {
            if (property && rule.propertieToWatch.indexOf(property) < 0) {
                continue;
            }
            this.applyRule(context, rule);
        }
    }

    private applyRule(context: DetailViewContext, rule: ConditionalVisibilityUIListenerRule): void {
        const newVisibilty = rule.newVisbilityValue(context.genericObject.values);
        const elementToChange = context.getUIFactory<ControlFactory>(rule.propertieToToggleVisibility);
        if (elementToChange) {
            elementToChange.isVisible(newVisibilty);
        }
    }
}

ComponentManager.setUIListener('ConditionalVisibilityUIListener', ConditionalVisibilityUIListener, 'RADPresentation.HTMLClient.DefaultViewExtensions');